var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3077 5.33474L9.88754 4.87789L7.76924 0L5.65093 4.88526L0.230774 5.33474L4.34677 8.82L3.11047 14L7.76924 11.2516L12.428 14L11.1992 8.82L15.3077 5.33474ZM7.76924 9.87368L4.93477 11.5463L5.68862 8.39263L3.18585 6.27053L6.4877 5.99053L7.76924 3.02105L9.05831 5.99789L12.3602 6.27789L9.85739 8.4L10.6112 11.5537L7.76924 9.87368Z",
    fill: "#BB2649"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/star-outline.28e673fc70342fb1307f8e72a8ef3288.svg";
export { ForwardRef as ReactComponent };